

{
  "familyId": "GET-PROC-BTW",
  "questions": [
    {
      "id": "GET-PROC-BTW-001",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "fill_in",
      "question": "Een boekhouder controleert een factuur. Het totaalbedrag is €121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "data": {
        "acceptedAnswers": ["100", "€100", "€ 100", "100,00", "€100,00"],
        "unit": "€",
        "placeholder": "€ ..."
      },
      "correctAnswer": "€100",
      "conceptId": "vat_exclusive_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 0,
            "end": 121,
            "step": 20,
            "markers": [
              {"value": 0, "label": "€0"},
              {"value": 100, "label": "excl. BTW\n?"},
              {"value": 121, "label": "incl. BTW\n€121"}
            ],
            "label": "Prijs exclusief → inclusief (×1,21)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen",
            "content": "Prijs inclusief BTW = prijs exclusief × 1,21 (bij 21% BTW). Dus: prijs exclusief = prijs inclusief ÷ 1,21. Voorbeeld: €121 ÷ 1,21 = €100. Let op: je trekt NIET 21% van het totaal af — dat geeft een fout antwoord!",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De boekhouder moet de prijs exclusief BTW vinden. Inclusief 21% BTW betekent: prijs exclusief × 1,21 = €121. Dus prijs exclusief = €121 ÷ 1,21 = €100. Let op de veelgemaakte fout: je mag NIET 21% van €121 aftrekken (dat geeft €95,59 — fout!). De 21% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Controleer: €100 × 1,21 = €121 ✓.",
        "solutionSteps": [
          "Inclusief BTW = exclusief × 1,21",
          "Dus exclusief = inclusief ÷ 1,21",
          "€121 ÷ 1,21 = €100",
          "Controleer: €100 × 1,21 = €121 ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "GET-PROC-BTW-002",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een ondernemer koopt kantoorspullen voor €60,50 inclusief 21% BTW. Hoeveel is het BTW-bedrag?",
      "options": ["€10,50", "€12,71", "€50", "€21"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "money",
          "showWhen": "always",
          "data": {
            "amount": 60.50,
            "label": "Totaalbedrag inclusief BTW"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Stap 1: prijs exclusief = €60,50 ÷ 1,21 = €50. Stap 2: BTW = inclusief − exclusief = €60,50 − €50 = €10,50. Of: BTW = €50 × 0,21 = €10,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De ondernemer wil weten hoeveel BTW er in de prijs zit. Stap 1: prijs exclusief BTW = €60,50 ÷ 1,21 = €50. Stap 2: BTW = €60,50 − €50 = €10,50. Je kunt het ook checken: €50 × 0,21 = €10,50. Let op de veelgemaakte fout: 21% van €60,50 = €12,71 — maar dat is fout! De BTW is berekend over de prijs exclusief (€50), niet over de prijs inclusief (€60,50).",
        "solutionSteps": [
          "Prijs exclusief = €60,50 ÷ 1,21 = €50",
          "BTW-bedrag = inclusief − exclusief",
          "BTW = €60,50 − €50 = €10,50",
          "Of: BTW = €50 × 0,21 = €10,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €60,50 ÷ 1,21 = €50. BTW = €60,50 − €50 = €10,50.",
          "1": "Je dacht waarschijnlijk dat je 21% van €60,50 berekent: €60,50 × 0,21 = €12,71. Maar 21% BTW is over de prijs exclusief, niet over de prijs inclusief. Onthoud: eerst delen door 1,21, dan het verschil berekenen.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €50 is de prijs exclusief BTW, niet het BTW-bedrag. Onthoud: BTW = inclusief − exclusief = €60,50 − €50 = €10,50.",
          "3": "Je dacht waarschijnlijk dat het BTW-percentage gelijk is aan het BTW-bedrag. Maar 21% is een percentage, geen bedrag in euro's. Onthoud: BTW = prijs exclusief × 0,21."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-003",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "fill_in",
      "question": "Een accountant controleert een factuur van €181,50 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "data": {
        "acceptedAnswers": ["150", "€150", "€ 150", "150,00", "€150,00"],
        "unit": "€",
        "placeholder": "€ ..."
      },
      "correctAnswer": "€150",
      "conceptId": "vat_exclusive_uneven",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 0,
            "end": 200,
            "step": 50,
            "markers": [
              {"value": 0, "label": "€0"},
              {"value": 150, "label": "excl. BTW\n?"},
              {"value": 181.5, "label": "incl. BTW\n€181,50"}
            ],
            "label": "Prijs exclusief → inclusief (×1,21)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen",
            "content": "Prijs exclusief = prijs inclusief ÷ 1,21. €181,50 ÷ 1,21 = €150. Controleer: €150 × 1,21 = €181,50 ✓. Tip: je kunt ook rekenen: €150 × 0,21 = €31,50 BTW. €150 + €31,50 = €181,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De accountant deelt het totaalbedrag door 1,21: €181,50 ÷ 1,21 = €150. Dit is lastiger dan een 'mooi getal' zoals €121, maar de methode is hetzelfde. Tip: controleer altijd je antwoord door terug te rekenen: €150 × 1,21 = €181,50 ✓. Je kunt ook stap voor stap: €150 × 0,21 = €31,50 BTW. €150 + €31,50 = €181,50 ✓.",
        "solutionSteps": [
          "Exclusief = inclusief ÷ 1,21",
          "€181,50 ÷ 1,21 = €150",
          "Controleer: €150 × 1,21 = €181,50 ✓",
          "Of: €150 × 0,21 = €31,50 BTW, €150 + €31,50 = €181,50 ✓"
        ],
        "distractorExplanations": {}
      }
    },
    {
      "id": "GET-PROC-BTW-004",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een zzp'er stuurt een offerte. De prijs exclusief BTW is €350. Hoeveel betaalt de klant inclusief 21% BTW?",
      "options": ["€423,50", "€371", "€421", "€350,21"],
      "correctAnswer": 0,
      "conceptId": "vat_inclusive_from_exclusive",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.77,
      "stimulusAids": [
        {
          "type": "money",
          "showWhen": "always",
          "data": {
            "amount": 350,
            "label": "Offertebedrag exclusief BTW"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs inclusief BTW berekenen",
            "content": "Prijs inclusief = prijs exclusief × 1,21. €350 × 1,21 = €423,50. Of: BTW = €350 × 0,21 = €73,50, totaal = €350 + €73,50 = €423,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De zzp'er berekent de prijs inclusief BTW: €350 × 1,21 = €423,50. Of stap voor stap: BTW = €350 × 0,21 = €73,50. Totaal = €350 + €73,50 = €423,50. Dit is de omgekeerde berekening van 'exclusief vinden': bij exclusief → inclusief vermenigvuldig je met 1,21.",
        "solutionSteps": [
          "Prijs exclusief = €350",
          "BTW = €350 × 0,21 = €73,50",
          "Prijs inclusief = €350 + €73,50 = €423,50",
          "Of sneller: €350 × 1,21 = €423,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €350 × 1,21 = €423,50.",
          "1": "Je dacht waarschijnlijk dat je €350 + €21 = €371 kunt rekenen. Maar €21 is het percentage, niet het BTW-bedrag. Onthoud: BTW = €350 × 0,21 = €73,50.",
          "2": "Je dacht waarschijnlijk dat de BTW €71 is. Maar 21% van €350 = €73,50, niet €71. Onthoud: vermenigvuldig met 0,21, niet met 0,20.",
          "3": "Je dacht waarschijnlijk dat je €0,21 bij de prijs optelt. Maar 21% is een percentage, geen bedrag in euro's. Onthoud: 21% = 0,21 × de prijs."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-005",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een winkelier verkoopt een product voor €54,45 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€49,95", "€49,55", "€45,45", "€59,35"],
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_9pct",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "stimulusAids": [
        {
          "type": "numberline",
          "showWhen": "always",
          "data": {
            "start": 0,
            "end": 60,
            "step": 10,
            "markers": [
              {"value": 0, "label": "€0"},
              {"value": 49.95, "label": "excl. BTW\n?"},
              {"value": 54.45, "label": "incl. 9% BTW\n€54,45"}
            ],
            "label": "Prijs exclusief → inclusief (×1,09)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen (9%)",
            "content": "Bij 9% BTW deel je door 1,09 (niet door 1,21!). €54,45 ÷ 1,09 = €49,95. Controleer: €49,95 × 1,09 ≈ €54,45 ✓. Let op: niet alle producten hebben 21% BTW. Voedsel en boeken hebben 9% BTW.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De winkelier deelt door 1,09 (want 9% BTW, niet 21%): €54,45 ÷ 1,09 = €49,95. Controleer: €49,95 × 1,09 ≈ €54,45 ✓. Let op: bij 9% BTW deel je door 1,09, niet door 1,21! In Nederland geldt 9% BTW voor voedsel, boeken en medicijnen. Het standaardtarief is 21%.",
        "solutionSteps": [
          "Herken het BTW-tarief: 9% (niet 21%)",
          "Bij 9% BTW → deel door 1,09",
          "€54,45 ÷ 1,09 = €49,95",
          "Controleer: €49,95 × 1,09 ≈ €54,45 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €54,45 ÷ 1,09 = €49,95.",
          "1": "Je dacht waarschijnlijk dat je 9% van €54,45 aftrekt: €54,45 − €4,90 = €49,55. Maar 9% BTW is over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,09.",
          "2": "Je dacht waarschijnlijk dat je €54,45 − €9 = €45,45 kunt rekenen. Maar €9 is het percentage, niet het BTW-bedrag. Onthoud: deel door 1,09.",
          "3": "Je dacht waarschijnlijk dat je 9% moet optellen. Maar de BTW zit er al in bij 'inclusief'. Onthoud: bij inclusief BTW deel je, je telt niet op."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-006",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een loodgieter stuurt een rekening van €302,50 inclusief 21% BTW. Hoeveel BTW heeft de klant betaald?",
      "options": ["€52,50", "€63,53", "€250", "€302,50"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_from_inclusive",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "money",
          "showWhen": "always",
          "data": {
            "amount": 302.50,
            "label": "Rekening loodgieter (incl. BTW)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW-bedrag uit inclusief prijs",
            "content": "Stap 1: prijs exclusief = €302,50 ÷ 1,21 = €250. Stap 2: BTW = €302,50 − €250 = €52,50. Of: BTW = €250 × 0,21 = €52,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De klant wil weten hoeveel BTW er in de rekening van de loodgieter zit. Stap 1: prijs exclusief = €302,50 ÷ 1,21 = €250. Stap 2: BTW = €302,50 − €250 = €52,50. Check: €250 × 0,21 = €52,50 ✓. Let op: 21% van €302,50 = €63,53 — dat is NIET het juiste BTW-bedrag, want de BTW is berekend over €250 (exclusief), niet over €302,50 (inclusief).",
        "solutionSteps": [
          "Prijs exclusief = €302,50 ÷ 1,21 = €250",
          "BTW = inclusief − exclusief",
          "BTW = €302,50 − €250 = €52,50",
          "Of: BTW = €250 × 0,21 = €52,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €302,50 ÷ 1,21 = €250. BTW = €302,50 − €250 = €52,50.",
          "1": "Je dacht waarschijnlijk dat je 21% van €302,50 berekent: €302,50 × 0,21 = €63,53. Maar 21% BTW is over de prijs exclusief (€250), niet over de prijs inclusief. Onthoud: eerst delen door 1,21.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €250 is de prijs exclusief, niet de BTW. Onthoud: BTW = inclusief − exclusief.",
          "3": "Je dacht waarschijnlijk dat het hele bedrag BTW is. Maar €302,50 is de totaalprijs inclusief BTW. De BTW is slechts een deel daarvan: €52,50."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-007",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een webdesigner rekent €75 per uur exclusief BTW. Ze werkt 8 uur. Hoeveel betaalt de klant inclusief 21% BTW?",
      "options": ["€726", "€621", "€600", "€675"],
      "correctAnswer": 0,
      "conceptId": "vat_multi_step",
      "variantIndex": 7,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW berekenen in twee stappen",
            "content": "Stap 1: totaal exclusief = uurprijs × uren = €75 × 8 = €600. Stap 2: inclusief BTW = €600 × 1,21 = €726. Tip: de volgorde maakt niet uit. Je kunt ook eerst €75 × 1,21 = €90,75 per uur rekenen, en dan × 8 = €726.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Dit is een meerstapsvraag. Eerst berekent de webdesigner het totaal exclusief BTW: €75 × 8 = €600. Dan berekent ze de prijs inclusief BTW: €600 × 1,21 = €726. Of stap voor stap: BTW = €600 × 0,21 = €126, totaal = €600 + €126 = €726. Tip: de volgorde maakt niet uit — je kunt ook eerst het uurtarief inclusief BTW berekenen (€75 × 1,21 = €90,75) en dan × 8 = €726.",
        "solutionSteps": [
          "Totaal exclusief = €75 × 8 = €600",
          "Inclusief BTW = €600 × 1,21 = €726",
          "Of: BTW = €600 × 0,21 = €126, totaal = €600 + €126 = €726 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €75 × 8 = €600, en €600 × 1,21 = €726.",
          "1": "Je hebt waarschijnlijk een rekenfout gemaakt bij het vermenigvuldigen. €75 × 8 = €600, en €600 × 1,21 = €726 (niet €621). Onthoud: controleer je berekening door terug te rekenen.",
          "2": "Je dacht waarschijnlijk dat €600 het eindantwoord is. Maar €600 is de prijs exclusief BTW. De klant betaalt inclusief BTW: €600 × 1,21 = €726. Onthoud: de klant betaalt altijd inclusief BTW.",
          "3": "Je dacht waarschijnlijk dat je €75 + BTW per uur rekent en dan × 8. Maar €75 is het uurtarief exclusief BTW. De BTW over 8 uur is: €600 × 0,21 = €126, niet €75. Onthoud: bereken eerst het totaal exclusief, dan de BTW."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-008",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een kapper betaalt €1.089 inclusief 21% BTW voor nieuwe apparatuur. Hoeveel kan de kapper aftrekken als BTW?",
      "options": ["€189", "€228,69", "€900", "€1.089"],
      "correctAnswer": 0,
      "conceptId": "vat_deduction",
      "variantIndex": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.69,
      "stimulusAids": [
        {
          "type": "money",
          "showWhen": "always",
          "data": {
            "amount": 1089,
            "label": "Aankoopbedrag apparatuur (incl. BTW)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW aftrekken als ondernemer",
            "content": "Ondernemers mogen de BTW aftrekken. Stap 1: prijs exclusief = €1.089 ÷ 1,21 = €900. Stap 2: BTW = €1.089 − €900 = €189. De kapper kan €189 aftrekken bij de Belastingdienst.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De kapper kan als ondernemer de BTW aftrekken bij de Belastingdienst. Stap 1: prijs exclusief = €1.089 ÷ 1,21 = €900. Stap 2: BTW = €1.089 − €900 = €189. De kapper kan €189 aftrekken. Check: €900 × 0,21 = €189 ✓. Let op: 21% van €1.089 = €228,69 — dat is NIET het juiste bedrag, want de BTW is berekend over €900 (exclusief).",
        "solutionSteps": [
          "Prijs exclusief = €1.089 ÷ 1,21 = €900",
          "BTW = inclusief − exclusief",
          "BTW = €1.089 − €900 = €189",
          "De kapper kan €189 aftrekken ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €1.089 ÷ 1,21 = €900. BTW = €1.089 − €900 = €189.",
          "1": "Je dacht waarschijnlijk dat je 21% van €1.089 berekent: €1.089 × 0,21 = €228,69. Maar 21% BTW is over de prijs exclusief (€900), niet over de prijs inclusief. Onthoud: eerst delen door 1,21.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €900 is de prijs exclusief, niet de BTW. De BTW is €1.089 − €900 = €189.",
          "3": "Je dacht waarschijnlijk dat het hele bedrag als BTW afgetrokken kan worden. Maar €1.089 is de totaalprijs. Alleen de BTW (€189) kan worden afgetrokken."
        }
      }
    }
  ]
}

